import React from 'react';
import styled from 'styled-components';
import {COLORS, SIZES} from '@fupa/fupa-uikit';
import {Info} from 'app/styles/InfoText';
import {LinkOnComponent} from 'app/styles/link';
import {ArrowBack} from '@mui/icons-material';

const NoteWithIcon = styled(Info)`
  &&& {
    display: inline-flex;
    align-items: flex-end;
    color: ${COLORS.fupaSecondary};
    margin: 0.5rem 0;
  }

  & svg {
    margin-right: ${SIZES['8']};
  }
`;

const BackToOptions = ({to, text}) => {
  return (
    <LinkOnComponent tabIndex='2' to={to}>
      <NoteWithIcon variant='body1'>
        <ArrowBack style={{color: COLORS.fupaSecondary, fontSize: SIZES[20]}} />
        {text}
      </NoteWithIcon>
    </LinkOnComponent>
  );
};

export {BackToOptions};
